import { startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { useLocale } from '../locale';

export interface DateRangeProps {
  start: string;
  end?: string | null;
  timezone?: string | null;
}

/**
 * @param start UTC start date.
 * @param end UTC end date.
 */
const DateRange = ({ start, end }: DateRangeProps) => {
  const { formatDate, locale, timezone } = useLocale();

  const startDate = startOfDay(toZonedTime(new Date(start), timezone));
  const endDate = startOfDay(toZonedTime(new Date(end || start), timezone));

  if (startDate.getTime() === endDate.getTime()) {
    return (
      <>
        {formatDate(startDate, 'display_full_date')}
      </>
    );
  }

  try {
    const formatted = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long', // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      day: 'numeric', // @ts-ignore-next-line
    }).formatRange(startDate, endDate);

    return <>{formatted}</>;
  } catch {
    return (
      <>
        {formatDate(startDate, 'display_full_date')}
        {' - '}
        {formatDate(endDate, 'display_full_date')}
      </>
    );
  }
};

export default DateRange;
